import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        textAlign:'left',
        height: 24,
        fontSize: 7,
        // width:'100%',
        padding:0
    },
    cell :{
        flexDirection: 'row',
        // width:'100%',
        // borderLeft: 1,
        // paddingLeft: 5,
        height: '100%',
    },
    itemcode: {
        width: '15%',
    },
    ean: {
        minWidth: '20%',         
    },
    qty: {
        minWidth: '10%',
    },
    unit: {
        minWidth: '10%'
    },
    description: {
        minWidth:'15%'
    },
    dicount: {
        minWidth: '10%'
    },
    igv: {
        minWidth: '5%',
    },
    isc: {
        minWidth: '5%',
    },
    total: {
        minWidth: '10%',
    },
    // description: {
    //     width: '60%',
    //     textAlign: 'left',
    //     borderRightColor: borderColor,
    //     borderRightWidth: 1,
    //     paddingLeft: 8,
    // },
    // qty: {
    //     width: '10%',
    //     borderRightColor: borderColor,
    //     borderRightWidth: 1,
    //     textAlign: 'right',
    //     paddingRight: 8,
    // },
    // rate: {
    //     width: '15%',
    //     borderRightColor: borderColor,
    //     borderRightWidth: 1,
    //     textAlign: 'right',
    //     paddingRight: 8,
    // },
    // amount: {
    //     width: '15%',
    //     textAlign: 'right',
    //     paddingRight: 8,
    // },
  });


const TableRow = ({items}) => {
    const rows = items.map( item => 
        <View style={styles.row} key={item.ItemCode.toString()}>
            <View style={[styles.cell,styles.itemcode,{backgroundColor:'green'}]}>
                <Text>{item.ItemCode}</Text>
            </View>
            <View style={[styles.cell,styles.ean,{backgroundColor:'blue'}]}>
                <Text>751233465464</Text>
            </View>
            <View style={[styles.cell,styles.qty,{backgroundColor:'green'}]}>
                <Text>1189999910</Text>
            </View>
            <View style={[styles.cell,styles.unit,{backgroundColor:'blue'}]}>
                <Text>16</Text>
            </View>
            <View style={[styles.cell,styles.description,{backgroundColor:'green'}]}>
                <Text>{item.Dscription}</Text>
            </View>
            <View style={[styles.cell,styles.dicount,{backgroundColor:'blue'}]}>
                <Text>100%</Text>
            </View>
            <View style={[styles.cell,styles.igv,{backgroundColor:'green'}]}>
                <Text>45,96</Text>
            </View>
            <View style={[styles.cell,styles.isc,{backgroundColor:'blue'}]}>
                <Text>,75166</Text>
            </View>
            <View style={[styles.cell,styles.total,{backgroundColor:'green'}]}>
                <Text>{(19,999999 * 1).toFixed(2)}</Text>
            </View>
        </View>
    )
    return (<Fragment>{rows}</Fragment> )
};
  
  export default TableRow